import { useState, useEffect } from 'react'
import {
  Stack,
  Button,
  Heading,
  Text,
  Box,
  Divider,
  Flex,
  Image,
  SimpleGrid,
  Badge,
  useMediaQuery,
  Spacer
} from '@chakra-ui/react'
import { ArrowBackIcon } from '@chakra-ui/icons'
import { Link, useNavigate } from 'react-router-dom'

import useAuth from '../../hooks/useAuth'
import clientAxios from '../../config/axios'
import { formatDate } from '../../utils/functionsValidateProduct'
import ProductImage from '../../components/ProductImage'

const quilmesImages = require.context('../../assets/images', true)

const Details = () => {
  const { setProduct, userRegister } = useAuth()
  const [products, setProducts] = useState([])
  const [survey, setSurvey] = useState({})
  const [userLogin, setUserLogin] = useState({})
  const [bottlerSelect, setBottler] = useState(() => {
    const bottlerSelect = sessionStorage.getItem('bottlerSelect')

    return bottlerSelect ? JSON.parse(bottlerSelect) : []
  })
  const [geoAreaSelect, setGeoArea] = useState(() => {
    const geoAreaSelect = sessionStorage.getItem('geoAreaSelect')

    return geoAreaSelect ? JSON.parse(geoAreaSelect) : []
  })
  const [schema, setSchema] = useState({
    userId: 0,
    date: '',
    distributorId: 0,
    channelId: 0,
    products: [
      {
        productId: '',
        price: 0
      }
    ]
  })
  const navigate = useNavigate()
  const [isLargerThan768] = useMediaQuery('(max-width: 780px)')

  /* The above code is using the useEffect hook to load the products from the sessionStorage. */
  useEffect(() => {
    const cargandoProductos = async () => {
      const data = await sessionStorage.getItem('products')
      const dataObeject = await sessionStorage.getItem('object')

      if (!data) {
        window.location.href = '/survey-information'
      }

      setProducts(JSON.parse(data))
      setProduct(JSON.parse(data))
      setSurvey(JSON.parse(dataObeject))
    }

    cargandoProductos()
  }, [])

  /* Destructuring the user object. */
  const { userId, name, surname } = userRegister
  /* Destructuring the survey object. */
  const {
    date,
    distributor,
    area,
    bottler,
    channel,
    idDistributor,
    idChannel
  } = survey

  /* The above code is using the useEffect hook to push the productId and price of each product into
  the schema.products array. */
  useEffect(() => {
    products.forEach((element) => {
      // si el precio del producto tiene , lo reemplazo por .
      const newPrice = element.price.replace(',', '.')

      schema.products.push({
        productId: Number(element.id),
        price: Number(newPrice)
      })
    })
  }, [products])

  /* Adding the date, userId, distributorId, geoAreaId, bottlerId, channelId, and products to the
  schema object. */
  useEffect(() => {
    const addingObjectSchema = () => {
      const productsSchema = schema.products.filter(
        (element) => element.productId !== ''
      )

      if (date !== undefined) {
        // pasar el date a formato YYYY-MM-DD
        const dateFormatted = formatDate(date)

        schema.date = dateFormatted
      }

      schema.userId = userId
      schema.distributorId = idDistributor
      schema.channelId = idChannel
      schema.products = productsSchema
    }

    addingObjectSchema()
  }, [schema, date, idDistributor, idChannel, userId])

  /**
   * It takes the form data, validates it, and then sends it to the server
   * @param e - the event object
   */
  const handleSubmit = (e) => {
    e.preventDefault()

    clientAxios
      .post('/survey', schema)
      .then((response) => {
        if (response.status === 201) {
          navigate('/success')
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  return (
    <Stack bg={'#F7F7F7'} w={{ base: '100%', md: '100%' }}>
      <form onSubmit={handleSubmit}>
        <Stack bg={'#FFF'}>
          <Box
            alignItems={'center'}
            bg={'#FFF'}
            display={'flex'}
            justifyContent={'center'}
            padding={4}
          >
            <Image
              alt='quilmes'
              h={'auto'}
              src={quilmesImages('./logo.svg')}
              w={'auto'}
            />
          </Box>
          <Divider />
          <Flex
            alignItems='center'
            bg={'#FFF'}
            gap='2'
            margin={'0 auto !important'}
            minWidth='max-content'
            paddingBottom={4}
            paddingTop={4}
            {...(isLargerThan768
              ? { flexDirection: 'column', width: '100%' }
              : { flex: 'row', width: '90%' })}
          >
            <Box {...(isLargerThan768 ? { width: '90%' } : {})}>
              <Link to={'/products'}>
                <ArrowBackIcon color={'#0A0808'} h={6} marginTop={2} w={6} />
              </Link>
            </Box>
            <Spacer />
            <Box
              display={'flex'}
              {...(isLargerThan768 ? { width: '90%' } : { width: '15%' })}
            >
              {!isLargerThan768
                ? (
                  <Button
                    margin={0}
                    type='submit'
                    variant='btn-quilmes'
                    w={'100%'}
                  >
                    Continuar
                  </Button>
                )
                : null}
            </Box>
          </Flex>
        </Stack>
        <Stack className='container-information' w={{ base: '90%', md: '90%' }}>
          <Heading
            color={'#0A0808'}
            fontSize={'2xl'}
            fontWeight={400}
            paddingTop={'2rem'}
          >
            Resumen
          </Heading>
          <Text fontSize={'16px'}>
            Antes de continuar verificá que los datos ingresados son correctos.
          </Text>

          {isLargerThan768
            ? (
              <>
                <Box
                  background={'#FFF'}
                  borderRadius={'5px'}
                  marginTop={'2rem !important'}
                >
                  <Flex padding={'1rem'}>
                    <Image
                      alt='user'
                      h={'auto'}
                      src={quilmesImages('./user.svg')}
                      w={'auto'}
                    />
                    <Text
                      fontSize={'18px'}
                      fontWeight={'700'}
                      paddingLeft={2}
                      paddingTop={1}
                    >
                      Usuario
                    </Text>
                  </Flex>
                  <Divider />
                  <Flex padding={'1rem'}>
                    <Text
                      fontSize={'16px'}
                      lineHeight={'22px'}
                      textTransform={'capitalize'}
                    >
                      {name || userLogin.name}
                    </Text>
                    <Text
                      fontSize={'16px'}
                      lineHeight={'22px'}
                      paddingLeft={'.5rem'}
                      textTransform={'capitalize'}
                    >
                      {surname || userLogin.surname}
                    </Text>
                  </Flex>
                </Box>

                <Box
                  background={'#FFF'}
                  borderRadius={'5px'}
                  marginTop={'2rem !important'}
                >
                  <Flex padding={'1rem'}>
                    <Image
                      alt='user'
                      h={'auto'}
                      src={quilmesImages('./information.svg')}
                      w={'auto'}
                    />
                    <Text
                      fontSize={'18px'}
                      fontWeight={'700'}
                      paddingLeft={2}
                      paddingTop={1}
                    >
                      Información
                    </Text>
                  </Flex>
                  <Divider />
                  <Box paddingBottom={4}>
                    <Text
                      fontSize={'16px'}
                      fontWeight={'700'}
                      lineHeight={'0px'}
                      padding={'1rem'}
                      paddingTop={'2rem'}
                      textTransform={'capitalize'}
                    >
                      Fecha
                    </Text>
                    <Text
                      fontSize={'16px'}
                      paddingLeft={'1rem'}
                      textTransform={'capitalize'}
                    >
                      {date}{' '}
                    </Text>

                    <Text
                      fontSize={'16px'}
                      fontWeight={'700'}
                      lineHeight={'0px'}
                      padding={'1rem'}
                      paddingTop={'2rem'}
                      textTransform={'capitalize'}
                    >
                      Distribuidor
                    </Text>
                    <Text
                      fontSize={'16px'}
                      paddingLeft={'1rem'}
                      textTransform={'capitalize'}
                    >
                      {distributor}{' '}
                    </Text>

                    {userRegister.preferences === null
                      ? geoAreaSelect.description !== null
                        ? (
                          <Box height='80px'>
                            <Text
                              fontSize={'16px'}
                              fontWeight={'700'}
                              lineHeight={'0px'}
                              padding={'1rem'}
                              paddingTop={'2rem'}
                              textTransform={'capitalize'}
                            >
                              Área
                            </Text>
                            <Text
                              fontSize={'16px'}
                              paddingLeft={'1rem'}
                              textTransform={'capitalize'}
                            >
                              { geoAreaSelect.description}{' '}
                            </Text>
                          </Box>
                        )
                        : null
                      : <Box height='80px'>
                        <Text
                          fontSize={'16px'}
                          fontWeight={'700'}
                          lineHeight={'0px'}
                          padding={'1rem'}
                          paddingTop={'2rem'}
                          textTransform={'capitalize'}
                        >
                          Área
                        </Text>
                        <Text
                          fontSize={'16px'}
                          paddingLeft={'1rem'}
                          textTransform={'capitalize'}
                        >
                          { geoAreaSelect.description}{' '}
                        </Text>
                      </Box>
                    }

                    {userRegister.preferences === null
                      ? bottlerSelect.description !== null
                        ? (
                          <Box height='80px'>
                            <Text
                              fontSize={'16px'}
                              fontWeight={'700'}
                              lineHeight={'0px'}
                              padding={'1rem'}
                              paddingTop={'2rem'}
                              textTransform={'capitalize'}
                            >
                              Embotellador
                            </Text>
                            <Text
                              fontSize={'16px'}
                              paddingLeft={'1rem'}
                              textTransform={'capitalize'}
                            >
                              { bottlerSelect.description}{' '}
                            </Text>
                          </Box>
                        )
                        : null
                      : <Box height='80px'>
                        <Text
                          fontSize={'16px'}
                          fontWeight={'700'}
                          lineHeight={'0px'}
                          padding={'1rem'}
                          paddingTop={'2rem'}
                          textTransform={'capitalize'}
                        >
                          Embotellador
                        </Text>
                        <Text
                          fontSize={'16px'}
                          paddingLeft={'1rem'}
                          textTransform={'capitalize'}
                        >
                          { bottlerSelect.description}{' '}
                        </Text>
                      </Box>
                    }

                    <Text
                      fontSize={'16px'}
                      fontWeight={'700'}
                      lineHeight={'0px'}
                      padding={'1rem'}
                      paddingTop={'2rem'}
                      textTransform={'capitalize'}
                    >
                      Canal
                    </Text>
                    <Text
                      fontSize={'16px'}
                      paddingLeft={'1rem'}
                      textTransform={'capitalize'}
                    >
                      {channel}{' '}
                    </Text>
                  </Box>
                </Box>
              </>
            )
            : (
              <Stack display={'flex'} flexDirection={'row'} gap={4}>
                <Box
                  background={'#FFF'}
                  borderRadius={'5px'}
                  marginTop={'2rem !important'}
                  w={'20%'}
                >
                  <Flex padding={'1rem'}>
                    <Image
                      alt='user'
                      h={'auto'}
                      src={quilmesImages('./user.svg')}
                      w={'auto'}
                    />
                    <Text
                      fontSize={'16px'}
                      fontWeight={'700'}
                      paddingLeft={2}
                      paddingTop={1}
                    >
                      Usuario
                    </Text>
                  </Flex>
                  <Divider />
                  <Flex padding={'1rem'} paddingBottom={'3rem'}>
                    <Text
                      fontSize={'16px'}
                      lineHeight={'22px'}
                      textTransform={'capitalize'}
                    >
                      {name || userLogin.name}
                    </Text>
                    <Text
                      fontSize={'16px'}
                      lineHeight={'22px'}
                      paddingLeft={'.5rem'}
                      textTransform={'capitalize'}
                    >
                      {surname || userLogin.surname}
                    </Text>
                  </Flex>
                </Box>
                <Box
                  background={'#FFF'}
                  borderRadius={'5px'}
                  marginTop={'2rem !important'}
                  w={'80%'}
                >
                  <Flex padding={'1rem'}>
                    <Image
                      alt='user'
                      h={'auto'}
                      src={quilmesImages('./information.svg')}
                      w={'auto'}
                    />
                    <Text
                      fontSize={'16px'}
                      fontWeight={'700'}
                      paddingLeft={2}
                      paddingTop={1}
                    >
                      Información
                    </Text>
                  </Flex>
                  <Divider />
                  <SimpleGrid columns={[3, 4, 5]} paddingTop={3} spacing='10px'>
                    <Box height='80px' paddingLeft={4}>
                      <Text
                        fontSize={'16px'}
                        fontWeight={'700'}
                        textTransform={'capitalize'}
                      >
                        Fecha
                      </Text>
                      <Text fontSize={'16px'} textTransform={'capitalize'}>
                        {date}{' '}
                      </Text>
                    </Box>
                    <Box height='80px' paddingLeft={2}>
                      <Text
                        fontSize={'16px'}
                        fontWeight={'700'}
                        textTransform={'capitalize'}
                      >
                        Distribuidor
                      </Text>
                      <Text fontSize={'16px'} textTransform={'capitalize'}>
                        {distributor}{' '}
                      </Text>
                    </Box>
                    {userRegister.preferences === null
                      ? geoAreaSelect.description !== null
                        ? (
                          <Box height='80px' paddingLeft={2}>
                            <Text
                              fontSize={'16px'}
                              fontWeight={'700'}
                              lineHeight={'0px'}
                              padding={'.8rem 0rem'}
                              textTransform={'capitalize'}
                            >
                              Área
                            </Text>
                            <Text
                              fontSize={'16px'}
                              textTransform={'capitalize'}
                            >
                              { geoAreaSelect.description}{' '}
                            </Text>
                          </Box>
                        )
                        : null
                      : <Box height='80px' paddingLeft={2}>
                        <Text
                          fontSize={'16px'}
                          fontWeight={'700'}
                          lineHeight={'0px'}
                          padding={'.8rem 0rem'}
                          textTransform={'capitalize'}
                        >
                          Área
                        </Text>
                        <Text
                          fontSize={'16px'}
                          textTransform={'capitalize'}
                        >
                          { geoAreaSelect.description}{' '}
                        </Text>
                      </Box>
                    }

                    {userRegister.preferences === null
                      ? bottlerSelect.description !== null
                        ? (
                          <Box height='80px' paddingLeft={2}>
                            <Text
                              fontSize={'16px'}
                              fontWeight={'700'}
                              lineHeight={'0px'}
                              padding={'.8rem 0rem'}
                              textTransform={'capitalize'}
                            >
                              Embotellador
                            </Text>
                            <Text
                              fontSize={'16px'}
                              textTransform={'capitalize'}
                            >
                              { bottlerSelect.description}{' '}
                            </Text>
                          </Box>
                        )
                        : null
                      : <Box height='80px' paddingLeft={2}>
                        <Text
                          fontSize={'16px'}
                          fontWeight={'700'}
                          lineHeight={'0px'}
                          padding={'.8rem 0rem'}
                          textTransform={'capitalize'}
                        >
                          Embotellador
                        </Text>
                        <Text
                          fontSize={'16px'}
                          textTransform={'capitalize'}
                        >
                          { bottlerSelect.description}{' '}
                        </Text>
                      </Box>
                    }
                    <Box height='80px' paddingLeft={2}>
                      <Text
                        fontSize={'16px'}
                        fontWeight={'700'}
                        textTransform={'capitalize'}
                      >
                        Canal
                      </Text>
                      <Text fontSize={'16px'} textTransform={'capitalize'}>
                        {channel}{' '}
                      </Text>
                    </Box>
                  </SimpleGrid>
                </Box>
              </Stack>
            )}

          <Box
            background={'#FFF'}
            borderRadius={'5px'}
            flexDirection={'row'}
            marginTop={'2rem !important'}
          >
            <Flex padding={'1rem'} w={'100%'}>
              <Image
                alt='user'
                h={'auto'}
                src={quilmesImages('./products.svg')}
                w={'auto'}
              />
              <Text
                fontSize={'18px'}
                fontWeight={'700'}
                paddingLeft={2}
                w={'100%'}
              >
                Productos
              </Text>
              <Link
                _hover={{ textDecoration: 'none' }}
                to='/products'
              >
                <Text color={'#DB580B'} fontWeight={'700'} paddingTop={'.2rem'}>Editar</Text>
              </Link>
            </Flex>
          </Box>
          <Stack
            className='container-bar'
            overflow='auto'
            padding='2rem 0rem'
            w={{ base: '100%', md: '100%' }}
            {...(!isLargerThan768
              ? { paddingBottom: '2rem' }
              : { paddingBottom: '8rem' })}
          >
            <SimpleGrid columns={[2, 3, 4, 5, 6]} spacing='20px' w={'100%'}>
              {products.sort((a, b) => a.brand.description.toLowerCase() < b.brand.description.toLowerCase() ? -1 : 1).map(item => (
                <Stack
                  key={item.id}
                  bg={'#FFF'}
                  borderRadius={'10px'}
                  display={'flex'}
                  flexDirection={'row'}
                  justifyContent={'space-between'}

                >
                  <Box w={'100%'}>
                    <Box
                      display={'flex'}
                      flexDirection={'row'}
                      justifyContent={'space-between'}
                    >
                      <Text
                        fontSize='sm'
                        fontWeight='bold'
                        height={'42px'}
                        marginLeft={2}
                        marginTop={3}
                      >
                        {item.brand.description}
                      </Text>
                      <ProductImage
                        item={item}
                      />
                    </Box>
                    <Text marginLeft={2} marginTop={0}>
                      {item.volume.description}
                    </Text>
                    <Stack marginLeft={2} marginTop={2}>
                      <Badge
                        bg={'#E1E1E1'}
                        borderRadius={'10px'}
                        color={'#3B3939'}
                        fontSize={'10px'}
                        fontWeight={'400'}
                        padding={'.1rem .8rem'}
                        w={'max-content'}
                      >
                        {item.material.description}
                      </Badge>
                      <Badge
                        bg={'#E1E1E1'}
                        borderRadius={'10px'}
                        color={'#3B3939'}
                        fontSize={'10px'}
                        fontWeight={'400'}
                        padding={'.1rem .8rem'}
                        w={'max-content'}
                      >
                        {item.returnability.description}
                      </Badge>
                    </Stack>
                    <Box
                      paddingBottom={3}
                      paddingLeft={2}
                      paddingRight={2}
                      paddingTop={6}
                    >
                      <Text
                        border={'1px solid #E1E1E1'}
                        borderRadius={'10px'}
                        fontSize={'14px'}
                        fontWeight={700}
                        padding={'.5rem 1rem'}
                        w={'90%'}
                      >
                        $ {item.price}
                      </Text>
                    </Box>
                  </Box>
                </Stack>
              ))}
            </SimpleGrid>
          </Stack>
          {isLargerThan768 && (
            <Box
              alignItems={'center'}
              bg={'#F7F7F7'}
              bottom={0}
              justifyContent={'center'}
              marginTop={'-.5rem !important'}
              paddingBottom={'2rem'}
              paddingTop='1rem'
              position={'fixed'}
              w={'90%'}
            >
              <Button
                fontSize={'14px'}
                type='submit'
                variant={'btn-quilmes'}
                w={'100%'}
              >
                Guardar
              </Button>
            </Box>
          )}
        </Stack>
      </form>
    </Stack>
  )
}

export default Details
